export enum NvRapporteringStatus {
  NotApplicable = "NotApplicable",
  WaitingForReport = "WaitingForReport",
  Completed = "Completed",
  Ignored = "Ignored",
}
